import React from "react";
import NavigateBack from "../../components/navigateBack";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";

import createPersistedState from "use-persisted-state";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Rapid3ScoreAreaChart from "./rapid3ScoreTracker";

const useTokenState = createPersistedState("token");
const usePIDState = createPersistedState("pid");

const RheumatoidArthritisScoreTrackerPage = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [tab, setTab] = React.useState(0);

  const history = useHistory();
  const [token] = useTokenState();
  const [pid] = usePIDState();

  const useStyles = makeStyles((theme) => ({
    selectedTab: {
      backgroundColor: "#0e426a",
      height: 50,
      color: "#ffffff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
    unselectedTab: {
      backgroundColor: "#97d1fa57",
      height: 50,
      color: "#0060a6b3",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
    disabled: {
      pointerEvents: "none",
      opacity: 0.5,
    },
    errorMessage: {
      color: "#d32f2f",
      textAlign: "center",
      padding: theme.spacing(2),
    },
  }));
  const classes = useStyles();

  return (
    <>
      <NavigateBack title="Rheumatoid Arthritis Tracker" />
      <div style={{ marginTop: "78px" }}>
        <Grid container spacing={0}>
          {/* Tab Navigation */}
          <Grid item xs={12}>
            <Container maxWidth="sm" disableGutters onClick={() => setTab(0)}>
              <Typography
                component="div"
                className={
                  tab === 0 ? classes.selectedTab : classes.unselectedTab
                }
              >
                RAPID3
              </Typography>
            </Container>
          </Grid>

          {/* Tab Content */}
          {tab === 0 && (
            <Grid item xs={12}>
              <Container maxWidth="sm" disableGutters>
                <Rapid3ScoreAreaChart />
              </Container>
            </Grid>
          )}
        </Grid>
      </div>
    </>
  );
};

export default RheumatoidArthritisScoreTrackerPage;
